<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" class="CompanyInfo">
    <el-tab-pane label="次数" name="first">

      <div>
        <div style="padding:5px 5px 5px 5px">
          <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>次数</b></p>

            <el-date-picker v-model="createdTime" type="month" placeholder="选择月" @change="monthChange2">
            </el-date-picker>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
              <el-button round @click="exportExNum">导出</el-button>
              <span>-</span>
            </p>

          </div>
        </div>

        <div style="display:flex;margin: 2px 0 20px 20px;">

          <div
            style="width:80px;line-height:40px;background-color: lightblue;color: black;padding: 2px 0;margin-right: 10px;">
            正常次数</div>

          <div style="width:80px;line-height:40px;background-color: #f56c6c;color: black;padding: 2px 0;">异常次数</div>
          
        </div>

        <template>
          <div style="display:flex;flex-wrap: wrap;border-right: 1px solid green;border-bottom: 1px solid green;"
            v-for="(item, index) in patrolPointListR" :key="item.id" :index="index">

            <p style="width:1.2%;">{{ item.patrolPointName }}</p>

            <div v-for="ite in item.patrolRecordVOList" :key="ite.id"
              style="width:3.1%;border-top: 1px solid green;border-left: 1px solid green;">

              <div style="padding:5px 0;font-size: 16px;" :index="index" v-if="index == 0">{{ ite.patrolDate }}</div>

              <div style="display:flex;">
                <div
                  style="background-color: lightblue;color: black;padding:5px 0;width: 50%;height: 40px;line-height: 40px;">
                  {{
    ite.patrolCount == null ? "-" : ite.patrolCount }}</div>

                <div style="background-color:#f56c6c;padding:5px 0;width: 50%;height: 40px;line-height: 40px;">{{
    ite.patrolAbnCount == null ? "-" : ite.patrolAbnCount }}</div>
              </div>
            </div>

          </div>
        </template>

      </div>
    </el-tab-pane>
    <el-tab-pane label="异常情况" name="fourth">

      <div>
        <div style="padding:5px 5px 5px 5px">
          <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>异常</b></p>

            <el-date-picker v-model="createdTime" type="month" placeholder="选择月" @change="monthChange">
            </el-date-picker>

            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
              <el-button round @click="exportExcel">导出</el-button>
              <span>-</span>
            </p>
          </div>
        </div>

        <template>
          <div style="overflow-x: scroll;">
            <div
              style="width:11000px;display:flex;flex-wrap: wrap;border-right: 1px solid green;border-bottom: 1px solid green;"
              v-for="(item, index) in patrolPointListA" :key="item.id" :index="index">

              <p style="width:0.5%;">{{ item.patrolPointName }}</p>

              <div v-for="ite in item.patrolRecordVOList" :key="ite.id"
                style="width:3.2%;border-top: 1px solid green;border-left: 1px solid green;">

                <div style="padding:5px 0;font-size: 16px;" :index="index" v-if="index == 0">{{ ite.patrolDate }}</div>

                <div style="display:flex;">

                  <div :class="index % 2 == 1 ? 'patrol-stat-tr' : 'patrol-stat-tr-odd'"
                    style="padding:5px 0;width: 95vw;" v-html="ite.remark == null ? '-' : ite.remark">
                  </div>

                </div>
              </div>

            </div>
          </div>
        </template>

      </div>
    </el-tab-pane>
  </el-tabs>

</template>

<script>
import router from '../../router';

export default {
  name: "PatrolStatistic",
  data() {
    return {
      token: this.getToken(),
      userId: this.getUserId(),
      companyId: this.getCompanyId(),

      createdTime: new Date(),

      patrolPointList: [],
      patrolPointId: '',
      empList: [],
      maker: '',

      pageIndex: -1,
      pageNum: -1,

      exportType: '',
      activeName: 'first',

      direction: 'rtl',
      id: '',
      companyName: '',
      patrolCountList: [{
        date: 1
      }, {
        date: 2
      }, {
        date: 3
      }, {
        date: 4
      }, {
        date: 5
      }, {
        date: 6
      }, {
        date: 7
      }],
      typeList: [{
        id: 0,
        name: '按巡检点（总次数）'
      }, {
        id: 1,
        name: '按巡检点（异常次数）'
      }, {
        id: 2,
        name: '按巡检人（总次数）'
      }, {
        id: 3,
        name: '按巡检人（异常次数）'
      }],
      patrolPointListR: [],
      patrolPointListA: []
    }
  },
  methods: {
    exportExNum(){

      this.$axios({
        method: "post",
        url: "/shiro/patrol/record/sta/num",
        data: {
          maker: this.maker,
          patrolPointId: this.patrolPointId,
          createdTime: this.createdTime,
          status: -1,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        },
        responseType: 'arraybuffer'
      }).then(result => {

        const data = result.data

        let objectUrl = result.config.url
        const blob = new Blob([data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })

        objectUrl = URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = objectUrl

        a.download = "异常次数统计.xlsx"
        a.click()
        a.remove()
        URL.revokeObjectURL(objectUrl)
      })
    },
    exportExcel() {

      this.$axios({
        method: "post",
        url: "/shiro/patrol/record/excel2",
        data: {
          maker: this.maker,
          patrolPointId: this.patrolPointId,
          createdTime: this.createdTime,
          status: -1,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        },
        responseType: 'arraybuffer'
      }).then(result => {

        const data = result.data

        let objectUrl = result.config.url
        const blob = new Blob([data], {
          type: 'application/vnd.ms-excel;charset=utf-8'
        })

        objectUrl = URL.createObjectURL(blob)
        const a = document.createElement("a")
        a.href = objectUrl

        a.download = "异常情况统计.xlsx"
        a.click()
        a.remove()
        URL.revokeObjectURL(objectUrl)
      })
    },
    handleClick(tab, event) {
      // console.log(tab, event)

      if (tab.index == '0') {

        this.monthChange2()
      } else {
        this.monthChange()
      }
    },
    monthChange() {

      this.$axios({
        method: "post",
        url: "/shiro/patrol/record/statistic",
        data: {
          maker: this.maker,
          patrolPointId: this.patrolPointId,
          createdTime: this.createdTime,
          status: -1,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        this.patrolPointListA = data.data
      })
    },
    monthChange2() {

      this.$axios({
        method: "post",
        url: "/shiro/patrol/record/statistic2",
        data: {
          maker: this.maker,
          patrolPointId: this.patrolPointId,
          createdTime: this.createdTime,
          status: -1,
          companyId: this.companyId
        },
        headers: {
          token: this.token
        }
      }).then(result => {

        const data = result.data

        this.patrolPointListR = data.data

      })
    }
  },
  mounted() {
    this.setDefaultPath('/patrolStatistic')

    this.monthChange2()
  }
};
</script>

<style>
.patrol-stat-tr {
  background-color: white;
}

.patrol-stat-tr-odd {
  background-color: lightblue;
}
</style>